const SplashScreen = () => {
    return (
        <div style={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {/* <h1>Loading...</h1> You can replace this with animation or logo */}
        </div>
    );
};
export default SplashScreen;